export default __webpack_public_path__ + "static/media/geracao_servico_horizontal.170be739.png";